import { ASSIGNMENT_TYPES } from "@/schemas/structure-assignment";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";
import { useMemo } from "react";

export const useSupervisorRole = (assignmentType?: string) =>
  useMemo(() => {
    switch (assignmentType) {
      case ASSIGNMENT_TYPES.RR_2_RD:
        return SYSTEM_ROLE_CODE.REGIONAL_DIRECTOR;
      case ASSIGNMENT_TYPES.RR_2_FAM:
        return SYSTEM_ROLE_CODE.FIELD_ACCOUNT_MANAGER;
      case ASSIGNMENT_TYPES.KAM_2_CSD:
        return SYSTEM_ROLE_CODE.CUSTOMER_SERVICE_DIRECTOR;
      default:
        return undefined;
    }
  }, [assignmentType]);
